module.exports = __webpack_public_path__ + "static/media/company1.bf4cf288.png";